import style from './MovieTitle.module.scss'
import RatingSvg from '../../../../photo/icon/rating.svg'
import LikeSvg from '../../../../photo/icon/like.svg'
import { useState } from 'react';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import CloseIcon from '@mui/icons-material/Close';
import { red } from '@mui/material/colors';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectMovie } from '../../../../redux/movieSlices/MovieSelector'

let MovieTitle = () => {

    let { movie } = useSelector(selectMovie)

    const navigate = useNavigate();

    var local: Array<string> = []
    const arr: string | null = localStorage.getItem('NameMovie');
    if (arr !== null) {
        local = JSON.parse(arr)
    }

    const [book, setBook] = useState(false)

    let add = () => {
        local.push(movie.title)
        localStorage.setItem('NameMovie', JSON.stringify(local))
        // local.length = 0
        setBook(true)
    }

    function localdel() {
        localStorage.clear()
        localStorage.removeItem('NameMovie')
        setBook(false)
    }

    function handleSubmit() {
        navigate(-1);
    }

    return (
        < div className={style.movie__title} style={{ backgroundImage: `url("${movie.background_image_original}")`, backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
            <div className={style.title__img}>
                <img src={movie.large_cover_image} />
                <div className={style.title__button}>
                    <a href={movie.url}><button className={style.img__button}> Watch Now</button></a>
                    {book ? <BookmarksIcon onClick={localdel} sx={{ fontSize: 40, color: red[700] }} />
                        : <BookmarksIcon onClick={add} sx={{ fontSize: 40 }} />}
                </div>
            </div>
            <div className={style.title__text}>
                <div className={style.text__name}>
                    {movie.title}
                </div>
                <div className={style.text__info}>
                    <div className={style.rating}>
                        <img src={RatingSvg} />
                        <span>{movie.rating} / 10</span>
                    </div>
                    <div className={style.likes}>
                        <img src={LikeSvg} /> {movie.like_count}
                    </div>
                    <div className={style.year}>
                        {movie.year} , {movie.mpa_rating}
                    </div>
                    <div className={style.time}>
                        {movie.runtime} minutes
                    </div>
                    <div className={style.genres}>
                        {movie.genres.map((el: string) => <div>• {el}</div>)}
                    </div>
                </div>
            </div>
            <div className={style.close} onClick={() => handleSubmit()}><CloseIcon sx={{ fontSize: 40 }} /></div>
        </div >
    )
}

export default MovieTitle;